/* eslint-disable import/prefer-default-export */
export const GET_DELIVERIES_SUCCESSFUL = "GET_DELIVERIES_SUCCESSFUL";
export const GET_DELIVERIES_ERROR = "GET_DELIVERIES_ERROR";
